module.exports = __webpack_public_path__ + "img/Produktbeispiel_8.87792406.jpg";